/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createTan } from '../../factoriesAny.js';
export var tanDependencies = {
  typedDependencies: typedDependencies,
  createTan: createTan
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesTan.generated.js
// module id = 1667
// module chunks = 0